/*
 * Authors: mariushirjanu
 * Created: 27/12/2022
 */

import { Injectable } from '@angular/core';
import * as _ from 'underscore';
import { IObject } from '../../../../../type_definitions/datatypes';

const SEP1:string = '\t';
const SEP2:string = '\f';

@Injectable()
export class CatalogOverviewFiltersUtilService {
  constructor() {
    /***/
  }

  public containsSelection(selectedFilters:IObject):boolean {
    let hasFilters = false;
    _.forEach(selectedFilters, (filterGroup:any) => {
      if (filterGroup?.length) {
        hasFilters = true;
      }
    });
    return hasFilters;
  }

  public selectionToParam(selectedFilters:IObject):string[] {
    if (!this.containsSelection(selectedFilters)) {
      return undefined;
    }

    //remove empty arrays
    selectedFilters = _.clone(selectedFilters);
    _.forEach(selectedFilters, (filterGroup:any, name:string) => {
      if (filterGroup && !filterGroup.length) {
        selectedFilters[ name ] = undefined;
      }
    });

    const param:string[] = [];
    _.forEach(selectedFilters, (filterGroup:IObject, name:string) => {
      if (filterGroup && filterGroup.length) {

        param.push(name + SEP1 + filterGroup.join(SEP2));
      }
    });

    return param;
  }

  public paramToSelection(param:string|string[]):IObject {
    const selectedFilters:IObject = {};
    if (param) {
      param = _.isArray(param)? param : [ param ];

      _.forEach(param, (filterGroup:string) => {
        if (filterGroup?.indexOf(SEP1) > 0) {
          const nameValues = filterGroup.split(SEP1);
          selectedFilters[ nameValues[ 0 ] ] = nameValues[ 1 ].split(SEP2);
        }
      });
    }

    return selectedFilters;
  }
}